'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUpTwoRectangles, iconArrowUpTwoRectanglesTag } from '@ni/nimble-components/dist/esm/icons/arrow-up-two-rectangles';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUpTwoRectangles };
export { iconArrowUpTwoRectanglesTag };
export const NimbleIconArrowUpTwoRectangles = wrap(IconArrowUpTwoRectangles);